<template>
  <app-page>
    <div class="content">
      <p>
        随着我们对珠宝玉石行业的不断探索和深入，随着翡翠王朝珠宝体系的逐步建立，我们对行业发展的专业化要求不断提升。 2016年初，翡翠王朝专家顾问委员会正式成立。在今后的工作中，我们将携手各位专家，致力于传播玉石文化，弘扬玉雕艺术，促进行业发展。
      </p>
      <img src="@/assets/images/about/expert_content_1.png" alt="">
      <p>
        张代明、肖永福、李贞昆、杨正纯、万凡、华国津、张磊接受聘书，成为翡翠王朝专家顾问委员会第一批成员。
      </p>
      <img src="@/assets/images/about/expert_content_2.png" alt="">
      <p>
        翡翠王朝专家顾问委员会成员由具有丰富实践经验和开拓创新精神的翡翠珠宝行业专家、学者、教育工作者组成。他们均有多年翡翠珠宝行业的从业或研究经历，专业性强，在业界有着较好的声誉。
      </p>
    </div>
    <div class="experts">
      <div class="expert" v-for="(value,index) in experts" :key="index">
        <span class="avatar">
          <img :src="value.avatar" alt="">
        </span>
        <div class="detail">
          <span class="name">{{value.name}}</span>
          <p class="description">
            {{value.description}}
          </p>
        </div>
      </div>
    </div>
    <about-footer></about-footer>
  </app-page>
</template>

<script>
  import AppPage from '../layouts/Main';
  import AboutFooter from './components/AboutFooter';
  import Avatar1 from '@/assets/images/about/expert_avatar_1.png';
  import Avatar2 from '@/assets/images/about/expert_avatar_2.png';
  import Avatar3 from '@/assets/images/about/expert_avatar_3.png';
  import Avatar4 from '@/assets/images/about/expert_avatar_4.png';
  import Avatar5 from '@/assets/images/about/expert_avatar_5.png';
  import Avatar6 from '@/assets/images/about/expert_avatar_6.png';
  import Avatar7 from '@/assets/images/about/expert_avatar_7.png';
    export default {
        name: 'contact',
        components: {
          AppPage,AboutFooter
        },
        data() {
            return {
              experts:[
                {
                  avatar:Avatar1,
                  name:'张代明',
                  description:'长期从事珠宝教育与珠宝文化、珠宝产业发展研究。原昆明理工大学宝石系主任和云南科技信息职业学院珠宝系主任。参与了云南省“翡翠分级标准”和“黄龙玉标准”制定，出版了《翡翠赌石实战攻略》、《开家珠宝店》等珠宝专著多部。'
                },
                {
                  avatar:Avatar2,
                  name:'肖永福',
                  description:'著名珠宝研究、鉴定和评估专家，GAC珠宝鉴定师。多次出国考察和讲学，在翡翠的评价、鉴赏、评估等方面有很深的造诣。发表珠宝方面论文300余篇，出版了《翡翠鉴赏与投资》《翡翠精品鉴赏》《赌石秘诀》、《彩色宝石》等翡翠及珠宝方面著作多部。 '
                },
                {
                  avatar:Avatar3,
                  name:'李贞昆',
                  description:'珠宝鉴赏、评估专家，岩矿鉴定工程师，玉文化的研究和传播者，昆明宝石厂的创建和首任厂长。具有深厚的翡翠毛料鉴别和价值评估功底。出版过《玉王翡翠》《翡翠佩戴》等专著。 '
                },
                {
                  avatar:Avatar4,
                  name:'杨正纯',
                  description:' 云南省地矿局高级地质工程师，珠宝鉴定、评估师，工艺美术师，词、曲作家。曾荣获全国“十年地质科普先进工作者”和“科学园丁”称号，创作了世界首支翡翠歌曲《翡翠之歌（玉王翡翠）》，发表文章多篇。 '
                },
                {
                  avatar:Avatar5,
                  name:'万凡 ',
                  description:'硕士生导师，云南艺术学院艺术设计学院设计学系主任。从业至今，先后完成了平面设计、空间设计、时尚珠宝等设计作品约190项，并获得国际级、国家级、省级等多种奖项。 '
                },
                {
                  avatar:Avatar6,
                  name:'华国津',
                  description:'中华玉雕艺术大师，中国工艺美术行业理事。其作品曾获中国玉石雕刻作品“天工奖”金银奖、云南省工艺美术第四届“工美杯”铜奖等玉雕奖项。为云南省多所高校客座教授，出版书籍《玉石加工与技术》。 '
                },
                {
                  avatar:Avatar7,
                  name:'张磊',
                  description:'昆明理工大学宝石专业青年教师，珠宝鉴定师。发表《缅甸珍珠价值亟待发掘》、《移动互联网背景下的翡翠珠宝品牌推广与营销》等论文数篇。长期根植于翡翠珠宝第一线，具有丰富的理论和实战经验。 '
                }
              ]
            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped >
  .content{
    padding: 0 0.21rem;
    background-color: rgba(255,255,255,1);
    p{
      text-align: left;
      text-indent: 0.4rem;
      padding: 0.4rem 0 0.13rem 0;
      font-size:0.1867rem;
      color:rgba(2,2,2,1);
      line-height:0.32rem;
      letter-spacing:2px;
    }
  }
  .experts{
    text-align: left;
    margin-top: 0.13rem;
    padding-top: 0.4rem;
    background-color: rgba(255,255,255,1);
    .expert{
      display: flex;
      padding: 0 0.21rem 0.4rem 0.21rem;
      .avatar{
        width: 0.8rem;
        height: 0.8rem;
        flex-shrink: 0;
        margin-right: 0.2rem;
      }
      .detail{
        .name{
          font-size:0.24rem;
          font-weight:500;
          color:rgba(29,29,29,1);
          line-height:0.24rem;
        }
        .description{
          font-size:0.1733rem;
          font-weight:400;
          color:rgba(78,78,78,1);
          line-height:0.2467rem;
          margin-top: 0.13rem;
        }
      }
    }
  }

</style>
